/**
 * Created by Alex Xia on 6/25/2019.
 * Description:
 */

export enum ContactScreenType {
    ContactScreen = 'contact'
}

export enum ContactScreenTabType {
    share = 'share',
    self = 'self'
}

export class ContactScreenTab {
    id: string;
    name: string;
    screenId: string;
    screenType: string;
    type: ContactScreenTabType;
    editable: boolean;

    constructor(id, name, screenId, screenType, type, editable) {
        this.id = id;
        this.name = name;
        this.screenId = screenId;
        this.screenType = screenType;
        this.type = type;
        this.editable = editable;
    }
}

export class ContactScreenConfig {
    id: string;
    name: string;
    description: string;
    type: ContactScreenType;
    isPublic: boolean;
    tabs: ContactScreenTab[];
    accessList: Array<string>;

    constructor() {
        this.id = '';
        this.name = '';
        this.description = '';
        this.type = ContactScreenType.ContactScreen;
    }
}
